import React from 'react';
import { StatsWidget, NavigationWidget, UpcomingShowsWidget, WhatsNewWidget } from './DashboardWidgets';
import DashboardEditor from '../dashboard/DashboardEditor';
import { useSubscription } from '../../contexts/SubscriptionContext';

const Dashboard = ({
  summary,
  upcomingShows,
  shows = {},
  totalInventoryValue,
  totalDocuments,
  onNavigate,
  loading,
  userProfile,
  isEditing,
  setIsEditing,
  isAdmin = true,
  setFeedbackModalOpen
}) => {
  const { billingEnabled, tier, isBeta } = useSubscription();
console.log('Subscription:', { billingEnabled, tier, isBeta });
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 pb-20">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <DashboardEditor isEditing={isEditing} setIsEditing={setIsEditing}>
          {/* Stats Section */}
          <div id="widget-stats">
            <StatsWidget 
              summary={summary} 
              totalInventoryValue={totalInventoryValue} 
              upcomingShows={upcomingShows}
              isAdmin={isAdmin}
            />
          </div>

          {/* Navigation Cards */}
          <div id="widget-navigation">
            <NavigationWidget 
              onNavigate={onNavigate}
              isAdmin={isAdmin}
              isEditing={isEditing} 
            />
          </div>

          {/* Bottom Section - Upcoming Shows & What's New side by side */}
          <div id="widget-bottom" className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            {/* Upcoming Shows - takes 2 columns on large screens */}
            <div className="lg:col-span-2">
              <UpcomingShowsWidget 
                upcomingShows={upcomingShows} 
                onNavigate={onNavigate}
                shows={shows}
              />
            </div>
            
            {/* What's New - takes 1 column */}
            <div>
              <WhatsNewWidget setFeedbackModalOpen={setFeedbackModalOpen} />
            </div>
          </div>
        </DashboardEditor>
      </div>
    </div>
  );
};

export default Dashboard;